import React, { useState } from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import { MdClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import Modal from 'react-responsive-modal';
import TaskDetailsWarning from '../TaskDetails/TaskDetailsWarning';
import { useTaskContext } from '../../../context/TaskContext';

const RoomSelectionPopup = ({ type, onClose, isOpen, onSelectRoom }) => {
  const { OnUpdateTask } = useTaskContext();
  const { user } = useSelector(state => state.message);
  const { active_task } = useSelector(state => state.task);
  const { conversations } = useSelector(state => state.message);
  const [searchQuery, setSearchQuery] = useState('');
  const [temp_room, setTemp_room] = useState(null);
  const [roomSelectWarning, setRoomSelectWarning] = useState(false);

  const filteredRooms = conversations?.filter(room =>
    room.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleRoomSelect = (room) => {
    if (type === 'create') {
      onSelectRoom(room);
      onClose();
    } else {
      setTemp_room(room);
      setRoomSelectWarning(true);
    }
  };

  const handleConfirmRoomChange = (room) => {
    setRoomSelectWarning(false);
    OnUpdateTask({
      conversation_id: temp_room?.conversation_id,
      conversation_name: temp_room?.title,
      conversation_img: temp_room?.conv_img,
      participants: temp_room?.participants,
      assign_to: [],
      observers: [],
    })
    onClose();
  }

  const closeIcon = <MdClose className="text-3xl mt-1 text-teal-600 dark:text-white " />;

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        container={document.getElementById('root')}
        center
        closeIcon={closeIcon}
        focusTrapped={false}
        classNames={{
          overlay: 'customOverlay',
          modal: 'customModal',
        }}
      >
        <div className="">
          <h2 className="text-xl font-semibold text-teal-600">
            Room
          </h2>
          <div className="pt-5">
            <div className="searchAndFilterBar" style={{ position: 'relative' }}>
              <div className="pb-2">
                <span className="text-white px-2 rounded py-1 roomColor text-sm bg-[#732BE2]">Room: {active_task?.conversation_name !== user?.name ? active_task?.conversation_name : 'You'}</span>
              </div>

              <div className="searchareaDiv">
                <div className="py-2 relative">
                  <input
                    className="_inputBar searchLeft bgSurfaceDark dark:border-none text-teal-600  text-sm"
                    type="text"
                    placeholder="Search Room"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  {searchQuery && <IoCloseCircle className="text-xl text-text-body absolute top-[18px] right-2" onClick={() => setSearchQuery('')} />}
                </div>

                <div className="h-[180px] overflow-auto">
                  {filteredRooms.length > 0 ? (
                    filteredRooms.map((room, index) => (
                      <p
                        key={index}
                        className="text-teal-600  text-sm cursor-pointer py-1.5"
                        tabIndex="0"
                        onClick={() => handleRoomSelect(room)}
                      >
                        {room.title}
                      </p>
                    ))
                  ) : (
                    <div className='flex items-center justify-center mt-20'>
                      <p className="text-teal-600  text-sm">No rooms found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <TaskDetailsWarning type="roomChange" isOpen={roomSelectWarning} onClose={() => setRoomSelectWarning(false)} onConfirm={handleConfirmRoomChange} />
    </>
  );
};

export default RoomSelectionPopup;